import { useCallback, useEffect, useRef, useState } from 'react'

// Make a scroll container (a sticky-header table) fill from wherever it sits
// down to near the viewport bottom, instead of a fixed maxHeight that leaves
// dead white space below on short lists. Runtime-measured so it works for
// both a tall header (My Centre) and a short one (Set Targets), and re-measures
// on resize. Same idea as the Parent Onboarding board's frozen-header box.
//
// Returns [callbackRef, maxHeight]: spread as
//   <TableContainer ref={callbackRef} style={{ maxHeight }} ... >
export const useFillHeight = (bottomGap = 20) => {
  const nodeRef = useRef(null)
  const [maxHeight, setMaxHeight] = useState('60vh')

  const measure = useCallback(() => {
    const node = nodeRef.current
    if (!node) return
    const top = node.getBoundingClientRect().top
    setMaxHeight(`${Math.max(240, window.innerHeight - top - bottomGap)}px`)
  }, [bottomGap])

  // Callback ref fires when the container mounts (after data loads) — measure
  // then; the resize listener keeps it right as the window changes.
  const setNode = useCallback(
    (node) => {
      nodeRef.current = node
      measure()
    },
    [measure]
  )

  useEffect(() => {
    window.addEventListener('resize', measure)
    return () => window.removeEventListener('resize', measure)
  }, [measure])

  return [setNode, maxHeight]
}
